import {post} from "./functions";

let uuid;

export function apiStart() {
    post('api.php', {task: 'start', quiz: quizID, questions: questionCount}).then(response => {
        uuid = response.payload.uuid;
    });
}

export function apiAnswer(correct) {
    post('api.php', {task: 'answer', uuid: uuid, correct: correct}).then(response => {
        console.log(response);
    });
}

export function apiEnding(score) {
    post('api.php', {task: 'ending', uuid: uuid, score: score}).then(response => {
        console.log(response);
    });
}